(() => {
	angular
		.module('main')
		.directive('createNewClientModal', createNewClientModal);

	createNewClientModal.$inject = ['randomStringGenerator', 'validationService'];

	function createNewClientModal(randomStringGenerator, validationService) {
		return {
			restrict: 'E',
			scope: {
				companyNameChecked: '=',
				client: '=',
				saveClient: '&',
				onClose: '&',
				isCreateClientModalSpinnningWheelActive: '=',
				businessNumberLabelName: '='
			},
			template: `
                    <div class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <form ng-submit="saveClient({id:client.id, event: $event})" class="form-horizontal form-group" role="form">
                                    <div class="modal-header pt-pb-15">
                                        <btn-close ng-click="onClose({event:$event})"></btn-close>
                                        <h3 class="modal-title" ng-show="!client.id">Add A New Client</h3>
                                        <h3 class="modal-title" ng-show="client.id">Edit Client</h3>
                                    </div>
                                    <div class="modal-body" style="padding: 30px!important">
                                        <div class="flex-row edit-contract-text">
                                            <div class="checkbox-squared">
                                                <input type="checkbox" id="{{checkboxId}}" ng-model="companyNameChecked"/>
                                                <label for="{{checkboxId}}"></label>
                                            </div>
                                            <label for="{{checkboxId}}">
                                                This client is a company and invoices will be addressed to the company.
                                            </label>
                                        </div>
                    
                                        <div class="row">
                                            <div class="col-xs-12" ng-show="companyNameChecked">
                                                <p class="form-group"></p>
                                                <label class="edit-contract-text control-label show-grid">Company</label>
                                                <div class="flex-row">
                                                    <input name="input" autocomplete="off" class="form-control" ng-model="client.companyName"/>
                                                </div>
                                                <label class="edit-contract-text control-label show-grid">{{businessNumberLabelName}}</label>
                                                <div class="flex-row">
                                                    <input data-number-input autocomplete="off" class="form-control" ng-model="client.businessNumber"/>
                                                </div>
                                            </div>
                                            <div class="col-xs-12 col-md-6">
                                                <label class="edit-contract-text control-label show-grid">First Name*</label>
                                                <input type="text" autocomplete="off" class="form-control" ng-model="client.firstName" required>
                                            </div>
                                            <div class="col-xs-12 col-md-6">
                                                <label class="edit-contract-text control-label show-grid">Last Name</label>
                                                <input type="text" autocomplete="off" class="form-control" ng-model="client.lastName">
                                            </div>
                                            <div class="col-xs-12">
                                                <label class="edit-contract-text control-label show-grid">Phone</label>
                                                <input data-number-input autocomplete="off" class="form-control" ng-model="client.phone">
                                            </div>
                                            <div class="col-xs-12">
                                                <label class="edit-contract-text control-label show-grid">Email*</label>
                                                <input type="email" autocomplete="off" class="form-control" ng-model="client.email" required>
                                            </div>
                                            <div class="col-xs-12">
                                                <label class="edit-contract-text control-label show-grid">Street Address</label>
                                                <input type="text" autocomplete="off" class="form-control" ng-model="client.address">
                                            </div>
                    
                                            <div class="col-xs-12 col-md-6">
                                                <label class="edit-contract-text control-label show-grid">Suburb/Town</label>
                                                <input type="text" autocomplete="off" class="form-control" ng-model="client.town">
                                            </div>
                                            <div class="col-xs-12 col-md-6">
                                                <label class="edit-contract-text control-label show-grid">Postcode/Zip</label>
                                                <input type="text" autocomplete="off" class="form-control" ng-model="client.postcode">
                                            </div>
                    
                                            <div class="col-xs-12">
                                                <label class="edit-contract-text control-label show-grid">State</label>
                                                <input type="text" autocomplete="off" class="form-control" ng-model="client.state">
                                            </div>
                                            <div class="col-xs-12">
                                                <label class="edit-contract-text control-label show-grid">Country</label>
                                                <input type="text" autocomplete="off" class="form-control" ng-model="client.country">
                                            </div>
                                            <div class="col-xs-12">
                                                <label class="edit-contract-text control-label show-grid">Client Notes</label>
                                                <sn-text-angular sn-model="client.notes"
                                                                 sn-file-drop-handler="disableDragDrop"
                                                                 sn-forbid-img-paste="true"
                                                                 sn-name="client_for_edit"></sn-text-angular>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer left">
                                        <button class="btn btn-success btn-submit pull-left mb--8"
                                        	type="submit"
                                            ng-disabled="isCreateClientModalSpinnningWheelActive"
                                            spinning-wheel is-spinning-wheel-active="isCreateClientModalSpinnningWheelActive">
                                            Save Client Profile
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
`,
			replace: true,
			transclude: true,
			link(scope) {
				const checkboxIndex = randomStringGenerator.getMixedString();
				const input = $('input');

				scope.checkboxId = `checkbox-squared-is-company-${checkboxIndex}`;

				scope.disableDragDrop = function() {
					return true;
				};

				$(document).on('shown.bs.modal', '#createNewClientModal', () => {
					validationService.isModalClosePrevented(input);
				});
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Modals/private/createNewClientModal.js